import { render, staticRenderFns } from "./NewPartnerSiteCustomTranslationModal.vue?vue&type=template&id=08764616&"
import script from "./NewPartnerSiteCustomTranslationModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerSiteCustomTranslationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports